import getSubscriptionPayment from '@/api/subscriptions/getSubscriptionPayment.endpoint';

const maxIntervals = 20;
const intervalTime = 3000;

export default async function waitForPendingSubscriptionPayment(
  subscriptionPaymentId
) {
  return new Promise((resolve, reject) => {
    let count = 0;
    let interval = setInterval(async () => {
      try {
        const subscriptionPayment = await getSubscriptionPayment(
          subscriptionPaymentId
        );
        if (subscriptionPayment.status != 'pending') {
          clearInterval(interval);
          if (subscriptionPayment.status == 'success') {
            resolve(subscriptionPayment);
          } else {
            reject(
              new Error('Something went wrong with the subscription payment')
            );
          }
        }
        if (count == maxIntervals) {
          clearInterval(interval);
          reject(new Error('Timeout'));
        }
        count++;
      } catch (e) {
        clearInterval(interval);
        reject(
          new Error(
            "We can't confirm if the payment was successfull, please try to login with new user"
          )
        );
      }
    }, intervalTime);
  });
}
